import { Injectable } from '@angular/core';
import { ApiClient } from './api-client.service';
import { ThemeSettings } from '../models/dto/theme-settings';
import { BehaviorSubject, filter, map } from 'rxjs';
import { Theme } from '../models';
import { ThemeService } from './theme.service';

interface ThemeState {
  themeSettings: ThemeSettings | null;
  loaded: boolean;
}

@Injectable({ providedIn: 'root' })
export class ThemeStateService {
  private settingsSubject = new BehaviorSubject<ThemeState>({
    themeSettings: null,
    loaded: false,
  });

  themeSettings$ = this.settingsSubject.asObservable().pipe(
    filter((x) => x.loaded),
    map((state) => state.themeSettings!)
  );

  constructor(
    private apiClient: ApiClient,
    private themeService: ThemeService
  ) {}

  loadThemeSettings(url: string) {
    if (this.settingsSubject.value.loaded) {
      return;
    }

    this.apiClient.get<ThemeSettings>(url).subscribe((themeSettings) => {
      this.settingsSubject.next({ themeSettings, loaded: true });

      const theme: Theme = {
        themeColour: themeSettings.themeColour,
        themeContrastColour: themeSettings.themeContrastColour,
      };
      this.themeService.setTheme(theme);
    });
  }
}
